import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import * as _ from 'lodash';
import {Router} from '@angular/router';
import { BodyContentModel } from 'src/shared/model/body-content-model';
import { TableCommonComponent } from '../table-common/table-common.component';

@Component({
  selector: 'dcu-body-content',
  templateUrl: './body-content.component.html',
  styleUrls: ['./body-content.component.scss']
})
export class BodyContentComponent {
  @Input() bodyContent: BodyContentModel;
  @Input() refresh = false;
  @Input() selectedRecords: any;
  @Input() selectedValueChange: any;
  @Input() keepSelectedValue: boolean;
  @Input() id: string;
  @Output() selectedRow = new EventEmitter();
  @Output() clickRow = new EventEmitter();
  @Output() onFilterStatus = new EventEmitter(); // for logic outside
  @Output() onSearchBox = new EventEmitter(); // for logic outside
  @Output() onAfterLoading = new EventEmitter(); // for logic outside
  @Output() contentChange = new EventEmitter();
  @Output() onCustomRouting = new EventEmitter();
  @Output() addNewCustomEvent = new EventEmitter();
  @Output() onChangeFilterBox = new EventEmitter();
  @Output() clearValue = new EventEmitter();

  @Input() showFilter = false;
  @Input() isCustomStatus = false;
  @Input() customTotalPage: string;
  @Input() scrollY: string;
  @Input() statusList: Array<any>;
  @Output() onChangeFilterBtn = new EventEmitter();
  @Input() scrollCollapse : boolean;
  @Input() serviceItem: string;
  @Input() isCustomCancelFilter: boolean;
  dataFilter: any;

  @Input()
  isEditDateDeactivate: boolean;

  @ViewChild('tbl', {static: false})
  tableRef: TableCommonComponent;

  constructor(protected router: Router) {
  }

  afterLoading(e): void {
    this.onAfterLoading.emit(e);
  }

  customRouting(e): void {
    this.onCustomRouting.emit(e);
  }

  addNewCustom(): void {
    this.addNewCustomEvent.emit();
  }

  onSelectedRow(e): void {
    this.selectedRecords = _.clone(e);
    this.selectedRow.emit(e);
  }

  onClickRow(e): void {
    this.clickRow.emit(e);
  }

  refreshList(): void {
    this.tableRef.refreshTable();
    this.contentChange.emit(true);
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }

  onChangeSearch(searchValue): void {
    // the logic need to be processed outside
    if (this.bodyContent.searchArea.customSearch) {
      this.onSearchBox.emit(searchValue);
    } else {
      if (this.bodyContent.searchArea.keySearchParam) {
        if (!this.bodyContent.tableConfig.customParams) {
          this.bodyContent.tableConfig.customParams = {};
        }
        if (searchValue) {
          this.bodyContent.tableConfig.customParams[this.bodyContent.searchArea.keySearchParam] = searchValue;
        } else {
          this.bodyContent.tableConfig.customParams = _.omit(
            this.bodyContent.tableConfig.customParams,
            this.bodyContent.searchArea.keySearchParam
          );
        }
        this.tableRef.reloadTableContent();
      } else {
        this.tableRef.onChangeSearchValue(searchValue);
      }
      this.onSearchBox.emit(searchValue);
    }
  }

  onChangeStatusValue(status): void {
    if (this.bodyContent.dropdown.customFilter) {
      this.onFilterStatus.emit(status);
    } else {
      this.tableRef.onChangeStatusValue(status);
      this.onFilterStatus.emit(status);
    }
  }

  onChangeFilter(paramFilters: any): void {
    if (!this.bodyContent.tableConfig.customParams) {
      this.bodyContent.tableConfig.customParams = {};
    }

    for (const key of _.keys(paramFilters)) {
      const searchValue = paramFilters[key];
      if (searchValue) {
        this.bodyContent.tableConfig.customParams[key] = searchValue;
      } else {
        this.bodyContent.tableConfig.customParams[key] = '';
      }
    }
    if (this.bodyContent.tableConfig.isApplyFilterToDataPost && this.bodyContent.tableConfig.methodPost) {
      this.bodyContent.tableConfig.dataPost = paramFilters;
      this.bodyContent.tableConfig.customParams = {};
    }
    this.dataFilter = paramFilters;
    this.onChangeFilterBtn.emit(paramFilters);
    this.tableRef.reloadTableContent();
  }

  onChangeDataFilter(formValue): void {
    this.onChangeFilterBox.emit(formValue);
  }

  onClearValue($event): void {
    this.clearValue.emit($event);
  }
}
